// extracted by mini-css-extract-plugin
export default {"pictureWrapper":"AboutUs_pictureWrapper__TeWkJ"};